import axios from "axios";
const CryptoJS = require("crypto-js");

require("dotenv").config();

let ADMIN_KEY = "";
let USER_KEY = "";
let RESOURCE_KEY = "";
let DefaultUser = {};

if (
  process.env.REACT_APP_MODE === "development" ||
  process.env.REACT_APP_MODE === "development-build") {
  ADMIN_KEY = process.env.REACT_APP_ADMIN_KEY_DEV;
  USER_KEY = process.env.REACT_APP_USER_KEY_DEV;
  RESOURCE_KEY = process.env.REACT_APP_RESOURCE_KEY_DEV;
} else if (process.env.REACT_APP_MODE === "production" || process.env.REACT_APP_MODE === "production-build") {
  ADMIN_KEY = process.env.REACT_APP_ADMIN_KEY_PROD;
  USER_KEY = process.env.REACT_APP_USER_KEY_PROD;
  RESOURCE_KEY = process.env.REACT_APP_RESOURCE_KEY_PROD;
} else if (process.env.REACT_APP_MODE === "test" || process.env.REACT_APP_MODE === "test-build") {
  ADMIN_KEY = process.env.REACT_APP_ADMIN_KEY_TEST;
  USER_KEY = process.env.REACT_APP_USER_KEY_TEST;
  RESOURCE_KEY = process.env.REACT_APP_RESOURCE_KEY_TEST;
}

if (process.env.REACT_APP_MODE === "development" || process.env.REACT_APP_MODE === "development-build") {
  DefaultUser = {
    email: process.env.REACT_APP_DEFAULT_USER,
    id: 35456843869,
  };
} else if (process.env.REACT_APP_MODE === "test" || process.env.REACT_APP_MODE === "test-build") {
  DefaultUser = {
    email: "modify.health.dev@gmail.com",
    id: 94394712363,
  };
} else {
  DefaultUser = {
    email: "modify.health.dev@gmail.com",
    id: 3461667618934,
  };
}


/**
 * Encrypting object to make requests on Shopify API
 * with Shopify proxy and without
 */
const CryptoTool = {
  adminUser: null,
  getDefaultUser: function () {
    return DefaultUser;
  },
  getShopUrl: function () {
    let url;
    let mode = process.env.REACT_APP_MODE;
    if (mode === "production" || mode === "production-build") {
      url = "https://modifyhealth.com/tools/softserve";
    } else if (mode === "test" || mode === "test-build") {
      url = "https://test-modifyhealth.myshopify.com/tools/softserve";
    } else {
      url = "https://devmodifyhealth.myshopify.com/tools/softserve";
    } 
    return url;
  },
  getApiUrl: function () {
    let url;
    let mode = process.env.REACT_APP_MODE;
    if (mode === "production" || mode === "production-build") {
      url = "https://modifyhealth-report.azurewebsites.net";
    } else if (mode === "test" || mode === "test-build") {
      url = "https://modifyhealth-report-dev.azurewebsites.net";
    } else {
      url = "https://modifyhealth-report-stage.azurewebsites.net";
    }
    return url;
  },
  getStoreUrl: function () {
    let url;
    let mode = process.env.REACT_APP_MODE;
    if (mode === "production" || mode === "production-build") {
      url = "https://modifyhealth.myshopify.com";
    }else if (mode === "test" || mode === "test-build") {
      url = "https://test-modifyhealth.myshopify.com";
    } else {
      url = "https://devmodifyhealth.myshopify.com";
    }
    return url;
  },
  requestAdminUser: function () {
    let apiUrl = this.getStoreUrl();

    return axios
      .get(apiUrl + "/admin/api/2019-04/users/current.json", {
        responseType: "json",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const staff = response.data.user;

          if (!staff.id) {
            this.adminUser = DefaultUser;
          } else {
            this.adminUser = staff;
          }
        } else {
          this.adminUser = DefaultUser;
        }

        return this.adminUser;
      });
  },

  getAdminUser: function () {
    return this.adminUser ? this.adminUser : DefaultUser;
  },
  replaceReservedCharacters: function (str) {
    //Double encoded + symbol, to compensate the Shopify proxy fix
    return str.replace(/\+/g, "%2B");
  },
  /**
   * Encrypting method for back-end API requests
   * @param {string} url - request url
   * @param {string} isResource - admin or customer email
   * @param {boolean} accountRequest - request from account pages, without Proxy
   */
  cryptUrl: function (url, isResource, accountRequest) {
    const prefix = url.indexOf("?") === -1 ? "?" : "&";
    let res = null;

    if (isResource) {
      if (typeof accountRequest === "undefined") {
        let user = this.getAdminUser();
        let hashInBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(user.email, RESOURCE_KEY));

        res =
          url + prefix + "email=" + this.replaceReservedCharacters(user.email) + "&hash=" + this.replaceReservedCharacters(hashInBase64);
      } else {
        let hashInBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(isResource, USER_KEY));

        res =
          url + prefix + "email=" + this.replaceReservedCharacters(isResource) + "&hash=" + this.replaceReservedCharacters(hashInBase64);
      }
    } else {
      let user =
        typeof window.shopifyUser !== "undefined" && window.shopifyUser && window.shopifyUser.email !== "" ? window.shopifyUser : null;

      if (user) {
        let hashInBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(user.email, USER_KEY));
        res =
          url + prefix + "email=" + this.replaceReservedCharacters(user.email) + "&hash=" + this.replaceReservedCharacters(hashInBase64);
      } else {
        user = this.getAdminUser();
        let hashInBase64 = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(user.id.toString(), ADMIN_KEY));
        res = url + prefix + "hash=" + this.replaceReservedCharacters(hashInBase64);
      }
    }

    return res;
  },
  isSafari: function () {
    return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
  },

  isIOs: function () {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/);
  },

  isMobileSafari: function () {
    return this.isSafari() && this.isIOs();
  },

  isAndroid: function () {
    return /android/i.test(window.navigator.userAgent);
  },
};

export default CryptoTool;
